module.exports = __webpack_public_path__ + "static/img/3.8a6c903.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/eng/3.png
// module id = u6oy
// module chunks = 0